(function () {
  var rootSelector = '.MM-ingredients-V1';
  var boundFlag = 'data-mm-ingredients-v1-js';
  var instances = new WeakMap();

  function setActiveDot(dots, index) {
    dots.forEach(function (dot, dotIndex) {
      if (dotIndex === index) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });
  }

  function slideOffset(track, slide) {
    var trackRect = track.getBoundingClientRect();
    var slideRect = slide.getBoundingClientRect();
    return track.scrollLeft + (slideRect.left - trackRect.left);
  }

  function maxScroll(track) {
    return Math.max(0, track.scrollWidth - track.clientWidth);
  }

  function leadingIndex(track, slides) {
    var closest = 0;
    var closestDistance = Infinity;

    slides.forEach(function (slide, index) {
      var distance = Math.abs(slideOffset(track, slide) - track.scrollLeft);
      if (distance < closestDistance) {
        closestDistance = distance;
        closest = index;
      }
    });

    return closest;
  }

  function updateArrows(prev, next, index, count) {
    if (prev) prev.disabled = index <= 0;
    if (next) next.disabled = index >= count - 1;
  }

  function destroy(root) {
    var instance = instances.get(root);
    if (!instance) return;

    instance.track.removeEventListener('scroll', instance.onScroll);
    instance.dots.forEach(function (dot) {
      dot.removeEventListener('click', instance.onDotClick);
    });

    if (instance.prev) {
      instance.prev.removeEventListener('click', instance.onPrev);
    }

    if (instance.next) {
      instance.next.removeEventListener('click', instance.onNext);
    }

    if (instance.onPointerDown) {
      instance.track.removeEventListener('pointerdown', instance.onPointerDown);
    }

    if (instance.onScrollEnd) {
      instance.track.removeEventListener('scrollend', instance.onScrollEnd);
    }

    if (instance.resizeObserver) {
      instance.resizeObserver.disconnect();
    }

    instances.delete(root);
  }

  function init(root) {
    if (!root) return;

    destroy(root);

    var track = root.querySelector('[data-mm-ingredients-v1-track]');
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll('[data-mm-ingredients-v1-slide]')) : [];
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-mm-ingredients-v1-dot]'));
    var prev = root.querySelector('[data-mm-ingredients-v1-prev]');
    var next = root.querySelector('[data-mm-ingredients-v1-next]');

    if (!track || slides.length === 0) return;

    var ticking = false;
    var programmatic = false;
    var selectedIndex = 0;
    var lastIndex = slides.length - 1;

    var limit = function () {
      return maxScroll(track);
    };

    var atEnd = function () {
      return track.scrollLeft >= limit() - 2;
    };

    var offsetFor = function (index) {
      var slide = slides[index];
      if (!slide) return 0;
      return Math.min(slideOffset(track, slide), limit());
    };

    var paint = function () {
      setActiveDot(dots, selectedIndex);
      updateArrows(prev, next, selectedIndex, slides.length);
    };

    var syncFromScroll = function () {
      if (atEnd()) {
        if (offsetFor(selectedIndex) < limit() - 2) selectedIndex = lastIndex;
      } else {
        selectedIndex = leadingIndex(track, slides);
      }
      paint();
    };

    var scrollToSelected = function () {
      var target = offsetFor(selectedIndex);
      paint();
      if (Math.abs(track.scrollLeft - target) <= 2) {
        programmatic = false;
        return;
      }
      programmatic = true;
      track.scrollTo({
        left: target,
        behavior: 'smooth'
      });
    };

    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        if (programmatic) {
          if (Math.abs(track.scrollLeft - offsetFor(selectedIndex)) <= 2) programmatic = false;
          paint();
        } else {
          syncFromScroll();
        }
        ticking = false;
      });
    };

    var onScrollEnd = function () {
      if (programmatic) {
        programmatic = false;
        paint();
        return;
      }
      syncFromScroll();
    };

    var onPointerDown = function () {
      programmatic = false;
    };

    var onDotClick = function (event) {
      var index = Number(event.currentTarget.getAttribute('data-mm-ingredients-v1-index'));
      if (isNaN(index) || !slides[index]) return;
      selectedIndex = index;
      scrollToSelected();
    };

    var onPrev = function () {
      if (selectedIndex <= 0) return;
      var index = selectedIndex - 1;
      if (offsetFor(selectedIndex) >= limit() - 2) {
        while (index > 0 && offsetFor(index) >= limit() - 2) index -= 1;
      }
      selectedIndex = index;
      scrollToSelected();
    };

    var onNext = function () {
      if (selectedIndex >= lastIndex) return;
      var index = selectedIndex + 1;
      if (offsetFor(index) >= limit() - 2) index = lastIndex;
      selectedIndex = index;
      scrollToSelected();
    };

    var resizeObserver = null;
    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(function () {
        if (!programmatic) syncFromScroll();
      });
      resizeObserver.observe(track);
    }

    track.addEventListener('scroll', onScroll, { passive: true });
    track.addEventListener('scrollend', onScrollEnd);
    track.addEventListener('pointerdown', onPointerDown);
    dots.forEach(function (dot) {
      dot.addEventListener('click', onDotClick);
    });

    if (prev) prev.addEventListener('click', onPrev);
    if (next) next.addEventListener('click', onNext);

    syncFromScroll();

    instances.set(root, {
      track: track,
      dots: dots,
      prev: prev,
      next: next,
      onScroll: onScroll,
      onScrollEnd: onScrollEnd,
      onPointerDown: onPointerDown,
      onDotClick: onDotClick,
      onPrev: onPrev,
      onNext: onNext,
      resizeObserver: resizeObserver
    });
  }

  function findRoot(target) {
    if (!target) return null;
    if (target.matches && target.matches(rootSelector)) return target;
    if (target.querySelector) return target.querySelector(rootSelector);
    return null;
  }

  function initAll() {
    document.querySelectorAll(rootSelector).forEach(init);
  }

  if (document.documentElement.getAttribute(boundFlag) !== 'true') {
    document.documentElement.setAttribute(boundFlag, 'true');

    document.addEventListener('shopify:section:load', function (event) {
      init(findRoot(event.target));
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var root = findRoot(event.target);
      if (root) destroy(root);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  } else {
    initAll();
  }
})();
